import { render, staticRenderFns } from "./SubjectEdit.vue?vue&type=template&id=0345cf02&"
import script from "./SubjectEdit.vue?vue&type=script&lang=js&"
export * from "./SubjectEdit.vue?vue&type=script&lang=js&"
import style0 from "./SubjectEdit.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&scpoed=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports